module.exports = __webpack_public_path__ + "img/37.936d641e.png";